import {
  DebounceSelect,
  Input,
  InputNumber,
  LookupTableSelect,
  Select,
  DatePicker,
} from "../DataEntry";
import dayjs from "dayjs";
import { ReactNode } from "react";

type DataIndexPath = string | number;
type DataIndex = string | DataIndexPath[];

type EditInCellProps = {
  type:
    | "Input"
    | "SelectOption"
    | "InputNumber"
    | "DebounceSelect"
    | "LookupTableSelect"
    | "DatePicker"
    | "SwitchToggle ";
  column: ReactNode;
  index: number;
  dataIndex: DataIndex; // ✅ hỗ trợ string hoặc [parent, child]
  editIndex: any;
  editProps?: any;

  /**
   * onChange sẽ nhận (value, dataIndex)
   * - value: giá trị mới
   * - dataIndex: string | (string|number)[]
   */
  onChange?: (value: any, dataIndex: DataIndex) => void;

  value?: any;
};

function toPath(dataIndex: DataIndex): DataIndexPath[] {
  return Array.isArray(dataIndex) ? dataIndex : [dataIndex];
}

function getByPath(obj: any, path: DataIndexPath[]) {
  return path.reduce((acc, key) => (acc == null ? acc : acc[key]), obj);
}

export const EditInCell = (p: EditInCellProps) => {
  const editIndex = p?.editIndex;
  const props = p?.editProps || {};

  const editingRow = editIndex?.find((ind: any) => ind.index == p.index);
  if (!editingRow) return p.column;

  const path = toPath(p.dataIndex);
  const keyTouched = path.join("."); // ✅ map path -> key string để lưu touchedFields

  const isTouched = !!editingRow?.touchedFields?.[keyTouched];

  // recordValue đọc theo path
  const recordValue = getByPath(editingRow?.record, path);

  // ✅ CHỈ dùng props.value khi CHƯA touched
  const mergedValue =
    !isTouched && props.value !== undefined ? props.value : recordValue;

  const emitChange = (value: any) => {
    p?.onChange?.(value, p.dataIndex);
  };

  const renderInput = () => (
    <Input
      {...props}
      value={mergedValue}
      style={{ width: "100%", ...props?.style }}
      onChange={(e: any) => emitChange(e)}
    />
  );

  const renderInputNumber = () => (
    <InputNumber
      {...props}
      value={mergedValue}
      style={{ width: "100%", ...props?.style }}
      onChange={(v: any) => emitChange(v)}
    />
  );

  const renderSelectOption = () => (
    <Select
      {...props}
      value={mergedValue}
      style={{ width: "100%", ...props?.style }}
      onChange={(v: any) => emitChange(v)}
    />
  );

  const renderDebounceSelect = () => (
    <DebounceSelect
      {...props}
      value={mergedValue}
      style={{ width: "100%", ...props?.style }}
      onChange={(v: any) => emitChange(v)}
    />
  );

  const renderLookupTableSelect = () => (
    <LookupTableSelect
      {...props}
      value={mergedValue}
      style={{ width: "100%", ...props?.style }}
      onChange={(v: any) => emitChange(v)}
    />
  );
  const renderDatePicker = () => (
    <DatePicker
      {...props}
      value={dayjs(mergedValue)}
      style={{ width: "100%", ...props?.style }}
      onChange={(v: any) => emitChange(v)}
    />
  );

  switch (p.type) {
    case "Input":
      return renderInput();
    case "InputNumber":
      return renderInputNumber();
    case "SelectOption":
      return renderSelectOption();
    case "DebounceSelect":
      return renderDebounceSelect();
    case "LookupTableSelect":
      return renderLookupTableSelect();
    case "DatePicker":
      return renderDatePicker();
    default:
      return p.column;
  }
};
